import React, { useEffect, useState } from "react";
import { Spinner, Row } from "@masterteam/mt-design-react";
import { getFile } from "../../helpers/attachments";

import styles from "./AsyncSvg.module.scss";

const AsyncSvg = ({
  color,
  defaultSvg,
  attachment,
  style = {},
  className,
  ...props
}) => {
  const [svg, setSvg] = useState(defaultSvg);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (attachment) {
      setIsLoading(true);
      getFile(attachment)
        .then(newFile => {
          setSvg(newFile.localURL);
        })
        .finally(() => setIsLoading(false));
    }
  }, [attachment]);

  return isLoading ? (
    <Row
      justify="center"
      align="center"
      style={{ ...style, background: "transparent" }}
      className={className}
      {...props}
    >
      <Spinner size="small" color={color} />
    </Row>
  ) : (
    <div
      className={`${styles.asyncSvg} ${className}`}
      style={{
        backgroundColor: color,
        "--img": `url(${svg})`,
        ...style
      }}
      {...props}
    />
  );
};

export default AsyncSvg;
